import React, { FC } from "react";

import { isObject } from "utils/isObject";

interface Props {
  error: any;
}

const FieldErrorFeedbackFormatter: FC<Props> = ({ error }) => {
  switch (true) {
    case typeof error === "string":
      return <>{error}</>;

    case isObject(error) && error.hasOwnProperty("key"):
      if (error.values && typeof error.values === "object") {
        let msg = error.key;
        Object.entries(error.values).forEach(
          ([k, v]) =>
            (msg = msg.replace(new RegExp(`\\{${k}\\}`, "g"), String(v))),
        );
        return <>{msg}</>;
      }
      return <>{error.key}</>;

    case isObject(error) && Object.values(error).length > 0:
      return <>{String(Object.values(error)[0])}</>;

    default:
      return <>Something went wrong</>;
  }
};

export default FieldErrorFeedbackFormatter;
